import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const AlertTriangleLarge = () => (
  <ImageIcon src={Images.AlertTriangleLarge} alt="empty-data/" />
);

export default AlertTriangleLarge;
